import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowDown, Crosshair, Terminal } from "lucide-react";
export default function VotrePartenaireEnSolutionsComplexes() {
  return <section data-section-id="224938" id="votre-partenaire-en-solutions-complexes" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col justify-center">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes scan {
            0% { top: -10%; opacity: 0; }
            10% { opacity: 1; }
            90% { opacity: 1; }
            100% { top: 110%; opacity: 0; }
          }
          @keyframes border-pulse {
            0% { box-shadow: 0 0 0 0 rgba(var(--color-primary-rgb), 0.4); }
            70% { box-shadow: 0 0 0 15px rgba(var(--color-primary-rgb), 0); }
            100% { box-shadow: 0 0 0 0 rgba(var(--color-primary-rgb), 0); }
          }
          .animate-scan {
            animation: scan 6s linear infinite;
          }
          .animate-border-pulse {
            animation: border-pulse 2s infinite;
          }
        `
    }} />

      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/quebec_luxury_penthouse_view.png)] bg-cover bg-center brightness-75 contrast-[1.1]" />
        {}
        <div className="absolute inset-0 bg-primary/40 backdrop-blur-[2px] !bg-[url(https://hypothequesjennymartel.com/wp-content/uploads/2026/05/quebec_luxury_penthouse_view.webp)]" />
      </div>

      {}
      <div className="absolute left-0 w-full h-[2px] bg-secondary/40 z-10 animate-scan pointer-events-none mix-blend-screen" />

      {}
      <div className="container relative z-20 mx-auto px-4 md:px-8 h-full flex flex-col justify-center">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {}
          

          {}
          <div className="lg:col-span-9 flex flex-col items-start">
            {}
            <h1 className="font-default font-bold leading-[0.85] tracking-tighter text-white mix-blend-normal mb-8 uppercase max-w-[12ch] !text-[50px] !w-[430px]">Courtier hypothécaire spécialisé en dossiers difficiles</h1>
            
            <p className="text-lg md:text-xl text-white/90 max-w-2xl mb-12 font-default font-semibold border-l-2 border-secondary pl-6">Mauvais crédit? Refus bancaire? Travailleur autonome?<div>Nous trouvons des solutions partout au Québec.<br />Les dossiers difficiles, c'est notre spécialité.&nbsp;</div></p>

            <div className="relative group">
              {}
              <div className="absolute -inset-1 bg-secondary/20 animate-ping opacity-20" />
              <div className="absolute inset-0 border border-secondary/50 animate-border-pulse pointer-events-none" />
              
              <Button asChild size="lg" className="relative rounded-md bg-background/90 backdrop-blur-xl border border-secondary/30 text-foreground hover:bg-secondary hover:text-secondary-foreground transition-all duration-300 h-16 px-10 text-lg font-default font-bold tracking-wider uppercase">
                <Link to="/nos-programmes">
                  Voir tous nos programmes
                  <Crosshair className="ml-3 size-5 opacity-70 group-hover:rotate-90 transition-transform duration-500" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center justify-center z-20 opacity-60 hover:opacity-100 transition-opacity cursor-pointer">
        <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-secondary/50 to-secondary mb-2" />
        <div className="relative">
          <ArrowDown className="size-6 text-secondary animate-bounce" />
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 border border-secondary/30 rotate-45 rounded-md" />
        </div>
        <span className="mt-4 font-mono text-[10px] tracking-[0.2em] text-secondary uppercase">Découvrir</span>
      </div>
    </section>;
}